import React, { useState } from "react";
import emailjs from "emailjs-com";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./firebase";
import Kalkulator from "./Kalkulator";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./AdminPanel";


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/*" element={<Kalkulator />} />
      </Routes>
    </Router>
  );
}